module.exports = __webpack_public_path__ + "static/media/icon-upload.eeefc1a8.svg";